import { AttributeGroup } from '@emm/core/models/attribute-group.model';
import { FormlyFieldConfigMap } from './formly-field-config.map';

const attributeGroupsPlaceHolder = 'Search for an Attribute Group';
export const attributeGroupsFilterFieldMap: FormlyFieldConfigMap<AttributeGroup> = {

    id: () => ({
        key: 'id',
        templateOptions: {
            label: 'Id',
            maxLength: 512,
            placeholder: attributeGroupsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name',
            maxLength: 512,
            placeholder: attributeGroupsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    description: () => ({
        key: 'description',
        templateOptions: {
            label: 'Description',
            maxLength: 512,
            placeholder: attributeGroupsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })

};

